module.exports = __webpack_public_path__ + "media/images/session-background-bf2db17ecdc83359c97c3a9c50286589.png";